module.exports = __webpack_public_path__ + "fonts/seguisb.bc74928e.ttf";